import { render, staticRenderFns } from "./ComputeLayoutComponent.vue?vue&type=template&id=611247bf"
import script from "./ComputeLayoutComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComputeLayoutComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ComputeLayoutComponent.vue?vue&type=style&index=0&id=611247bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports